export const ordersFr = {
    title: 'Commandes',
    list: 'Liste des commandes',
    detail: 'Détail de la commande',
    create: 'Créer une commande',
    delete: 'Supprimer la commande',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette commande ?',
    changeState: "Changer l'état",
    columns: {
        orderId: 'N° commande',
        name: 'Nom',
        state: 'État',
        customer: 'Client',
        requestedDeliveryDate: 'Date de livraison demandée',
        createdAt: 'Créé le',
        error: 'Erreur',
        actions: 'Actions'
    },
    filters: {
        createdFrom: 'Créée à partir du',
        createdTo: "Créée jusqu'au"
    },
    // TP-257 — les commandes que le poste refuse de mener à leur terme.
    //
    // Règle de rédaction reprise du poste : le motif d'abord avec ses valeurs,
    // la consigne de correction à la fin. L'opérateur et l'admin lisent ainsi
    // la même phrase de part et d'autre.
    orderErrors: {
        filter: 'Commandes en erreur',
        filterAll: 'Toutes',
        filterOnly: 'En erreur seulement',
        title: 'Cette commande ne peut pas être menée à son terme',
        none: '—',
        tag: 'En erreur',
        boundary:
            'La valeur {field} de la ligne {item} ({current}) sort des bornes de l’encodage du produit ({min}–{max}).',
        boundaryShort: 'Hors bornes',
        product: 'Le produit {productId} de la commande {orderRef} a été supprimé.',
        productUnidentified: 'Le produit de cette ligne a été supprimé.',
        productShort: 'Produit supprimé',
        unknown:
            'Cette commande porte une erreur que ce dashboard ne sait pas interpréter (« {type} »). Mettre le dashboard à jour.',
        unknownShort: 'Erreur inconnue',
        goToProduct: 'Ouvrir la fiche produit',
        goToItem: 'Voir la ligne de commande',
        deletedProduct:
            'Ce produit est supprimé. Le restaurer débloquera les commandes qui le référencent.'
    },
    model: {
        name: 'Nom de la commande',
        customer: 'Client',
        address: 'Adresse',
        comments: 'Commentaires',
        product: 'Produit',
        packaging: 'Commande',
        first_bib: 'Premier bib',
        last_bib: 'Dernier bib',
        csv: 'Fichier CSV',
        state: 'État',
        requestedDeliveryDate: 'Date de livraison souhaitée',
        eventDate: "Date de l'événement"
    },
    states: {
        pending: 'En attente',
        processing: 'En traitement',
        completed: 'Terminée',
        cancelled: 'Annulée',
        replaced: 'Remplacée'
    },
    table: {
        actions: {
            deleteTitle: 'Supprimer la commande {name}',
            deleteContent:
                'Êtes-vous sûr de vouloir supprimer la commande {name} ? Cette action est irréversible.'
        },
        title: 'Lignes de commande',
        addItem: 'Ajouter une ligne',
        removeItem: 'Supprimer la ligne',
        productName: 'Produit',
        quantity: 'Quantité',
        state: 'État',
        packaging: 'Conditionnement',
        comments: 'Commentaires',
        csvFile: 'Fichier CSV',
        downloadCsv: 'Télécharger le CSV',
        logoFile: 'Logo',
        csvPlaceholder: 'Sélectionner un fichier CSV (.csv)',
        logoPlaceholder: 'Sélectionner un logo (.png, .jpg)',
        useCsv: 'Utiliser un fichier CSV',
        firstBib: 'Premier dossard',
        lastBib: 'Dernier dossard',
        text1: 'Texte 1',
        text2: 'Texte 2',
        text3: 'Texte 3',
        noItems: 'Aucune ligne de commande',
        itemNumber: 'Ligne {n}'
    },
    batches: {
        title: 'Lots',
        state: 'État',
        first: 'Premier',
        last: 'Dernier',
        size: 'Taille',
        reprint: 'Réimpression des erreurs Argos ({count} étiquettes)',
        reprintOf: 'Réimpression du lot {batch} ({count} étiquettes)'
    },
    errors: {
        fetchFailed: 'Impossible de charger les commandes',
        createFailed: 'Impossible de créer la commande',
        createItemFailed: 'Impossible de créer la ligne de commande {n}',
        deleteFailed: 'Impossible de supprimer la commande',
        stateChangeFailed: "Impossible de changer l'état de la commande"
    },
    success: {
        created: 'Commande créée avec succès',
        deleted: 'Commande supprimée avec succès',
        stateChanged: 'État de la commande mis à jour avec succès'
    }
}
